var _defs, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrivateSecureIcon = function SvgPrivateSecureIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 418 418",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "private-secure-icon_svg__a",
    x1: 209,
    y1: 0,
    x2: 209,
    y2: 418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "private-secure-icon_svg__b",
    x1: 209.001,
    y1: 36.048,
    x2: 209.001,
    y2: 381.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "private-secure-icon_svg__c",
    x1: 208.999,
    y1: 74.085,
    x2: 208.999,
    y2: 343.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "private-secure-icon_svg__e",
    x1: 107.89,
    y1: 16.031,
    x2: 107.89,
    y2: 204.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3EDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "private-secure-icon_svg__g",
    x1: 162.783,
    y1: 111.886,
    x2: 185.808,
    y2: 111.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "private-secure-icon_svg__h",
    x1: 57,
    y1: 0,
    x2: 104.174,
    y2: 121.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#504CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A93E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "private-secure-icon_svg__i",
    x1: 57,
    y1: 0,
    x2: 104.174,
    y2: 121.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#504CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A93E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "private-secure-icon_svg__j",
    x1: 57,
    y1: 0,
    x2: 104.174,
    y2: 121.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#504CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A93E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "private-secure-icon_svg__k",
    x1: 57,
    y1: 0,
    x2: 104.174,
    y2: 121.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#504CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A93E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "private-secure-icon_svg__l",
    x1: 57,
    y1: 0,
    x2: 104.174,
    y2: 121.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#504CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A93E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "private-secure-icon_svg__m",
    x1: 57,
    y1: 0,
    x2: 104.174,
    y2: 121.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#504CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A93E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "private-secure-icon_svg__n",
    x1: 57,
    y1: 0,
    x2: 104.174,
    y2: 121.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#504CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A93E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "private-secure-icon_svg__o",
    x1: 57,
    y1: 0,
    x2: 104.174,
    y2: 121.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#504CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A93E5"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "private-secure-icon_svg__d",
    x: 0,
    y: 0,
    width: 215.78,
    height: 243.253,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.29
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.29
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0666667 0 0 0 0 0.137255 0 0 0 0 0.34902 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_48345"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.451
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.741
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0787427 0 0 0 0 0.306915 0 0 0 0 0.749837 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_0_48345",
    result: "effect2_dropShadow_0_48345"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_0_48345",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "private-secure-icon_svg__f",
    x: 93.26,
    y: 10.242,
    width: 100.048,
    height: 203.289,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.75,
    result: "effect1_foregroundBlur_0_48345"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 209,
    cy: 209,
    r: 209,
    fill: "#fff",
    fillOpacity: 0.09
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 209,
    cy: 209,
    r: 208.382,
    stroke: "url(#private-secure-icon_svg__a)",
    strokeOpacity: 0.7,
    strokeWidth: 1.236
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 209.001,
    cy: 208.997,
    r: 172.949,
    fill: "#fff",
    fillOpacity: 0.09
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 209.001,
    cy: 208.997,
    r: 172.331,
    stroke: "url(#private-secure-icon_svg__b)",
    strokeOpacity: 0.4,
    strokeWidth: 1.236
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 208.999,
    cy: 208.999,
    r: 134.914,
    fill: "#fff",
    fillOpacity: 0.09
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 208.999,
    cy: 208.999,
    r: 134.296,
    stroke: "url(#private-secure-icon_svg__c)",
    strokeOpacity: 0.5,
    strokeWidth: 1.236
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#private-secure-icon_svg__d)",
    transform: "translate(100.96 98)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.128 47.828c.602 3.636 3.667 22.144 4.131 46.335v.003c.364 24.097-1.934 36.089-2.38 38.417-.043.226-.125.621-.187.842-2.075 7.405-6.241 14.942-12.349 22.62-6.495 8.153-15.266 16.578-25.864 24.868-17.531 13.761-33.963 22.014-34.654 22.304a10.534 10.534 0 0 1-4.693 1.103 10.543 10.543 0 0 1-4.692-1.095c-.688-.291-17.1-8.518-34.64-22.283-10.594-8.282-19.365-16.707-25.856-24.864-5.717-7.19-9.733-14.262-11.923-21.216-.054-.17-.137-.493-.187-.664-.571-1.936-3.735-12.661-3.314-41.43.702-28.367 4.417-43.027 5.19-46.077.072-.28.317-.888.481-1.126 1.62-2.353 3.97-4.276 6.737-5.349 22.062-8.546 43.756-16.7 64.906-23.65a10.447 10.447 0 0 1 6.601 0c21.153 6.969 42.851 15.137 64.916 23.695 3.147 1.222 5.755 3.54 7.361 6.338.174.303.359.885.416 1.23Z",
    fill: "url(#private-secure-icon_svg__e)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#private-secure-icon_svg__f)",
    transform: "translate(100.96 98)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.02 95.873c-.464-24.19-3.529-42.699-4.131-46.334-.057-.344-.243-.927-.416-1.23-1.606-2.798-4.214-5.116-7.361-6.338-21.519-8.346-42.689-16.32-63.344-23.175l1.576-.52a10.446 10.446 0 0 1 6.601 0c21.153 6.97 42.851 15.137 64.916 23.695a14.705 14.705 0 0 1 7.361 6.339c.174.302.359.885.416 1.229.602 3.635 3.667 22.144 4.131 46.334v.004c.364 24.097-1.934 36.088-2.38 38.417-.043.225-.125.621-.187.842-2.075 7.405-6.241 14.941-12.349 22.62-6.495 8.153-15.266 16.578-25.864 24.867-17.531 13.762-33.963 22.014-34.654 22.305a10.544 10.544 0 0 1-4.693 1.103 10.544 10.544 0 0 1-4.692-1.096 6.383 6.383 0 0 1-.19-.088c1.929-.928 17.7-9.053 34.479-22.224 10.599-8.289 19.37-16.714 25.865-24.867 6.107-7.679 10.274-15.215 12.348-22.62.062-.221.144-.617.187-.842.447-2.329 2.745-14.32 2.381-38.417v-.004Z",
    fill: "url(#private-secure-icon_svg__g)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.799 14.866V55.65c0 .394-.2.591-.6.591l-4.435-.025c-.388-.005-.582-.2-.582-.582V14.74a.659.659 0 0 0-.358-.616c-5.101-2.88-5.917-10.22-.616-13.09C61.78-3.61 69.27 8.558 60.198 14.15a.796.796 0 0 0-.399.716Z",
    fill: "url(#private-secure-icon_svg__h)",
    transform: "translate(152 139.05)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.005 33.657c-12.45-1.115-22.732-6.355-30.85-15.72-.26-.306-.193-.417.2-.333 15.255 3.145 28.245.241 42.792-4.186 2.962-.907 6.55 3.212 7.889 5.759 2.072 3.928 1.107 13.231 1.032 17.817-.006.288-.153.45-.441.482-4.918.608-16.636 1.107-19.931-3.428a.934.934 0 0 0-.69-.391Zm51.563.274c-3.862 4.752-15.238 4.128-20.214 3.604-.316-.034-.474-.208-.474-.525.016-4.785-.858-12.774.698-16.835 1.582-4.11 5.01-7.698 9.904-6.308 14.122 4.02 26.438 6.957 41.285 3.687a.19.19 0 0 1 .207.09.191.191 0 0 1-.024.226c-8.134 9.387-18.411 14.644-30.833 15.77a.796.796 0 0 0-.55.291Zm-46.486 15.23c-2.747 5.15 8.546 7.664 12.516 8.546.532.122.543.28.033.474a22.634 22.634 0 0 0-6.64 3.903.81.81 0 0 1-.767.183c-6.407-1.548-13.123-5.75-12.008-13.173.974-6.425 5.775-8.364 11.709-8.072.699.033 1.484-.014 2.355-.142 4.472-.638 7.418 1.082 8.838 5.16.4 1.137.416 2.163.05 3.079-1.64 4.16-8.464 2.055-10.985-.125-1.456-1.265-4.045-1.798-5.101.166Z",
    fill: "url(#private-secure-icon_svg__i)",
    transform: "translate(152 139.05)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.874 49.352c-.907-1.814-3.145-1.89-4.543-.7-2.614 2.231-9.554 4.844-11.426.567-.472-1.082-.428-2.306.133-3.67 2.513-6.108 6.849-4.42 12.025-4.586 10.494-.324 14.971 11.518 6.882 17.551-6.383 4.76-16.31 5.676-24.474 6.333-10.57.84-14.53 7.274-3.562 13.424.35.2.346.393-.009.582l-4.269 2.314a.671.671 0 0 1-.69-.017c-2.37-1.398-4.028-2.821-4.977-4.27-6.849-10.402 2.996-16.393 12.142-17.617 4.377-.59 26.305-2.92 22.768-9.911Z",
    fill: "url(#private-secure-icon_svg__j)",
    transform: "translate(152 139.05)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.276 76.223c3.346-2.114 5.726-6.674 1.032-9.112-.555-.289-.524-.494.092-.616l5.883-1.165c.283-.056.497.044.641.3 6.533 11.683-9.595 17.725-17.251 20.521-4.086 1.481-8.938 6.866-3.005 10.228.233.138.233.274 0 .408l-3.361 1.872c-.51.288-.95.203-1.315-.258-5.243-6.574-1.781-12.716 4.735-16.186 3.795-2.022 8.205-3.237 12.55-5.992Z",
    fill: "url(#private-secure-icon_svg__k)",
    transform: "translate(152 139.05)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.817 67.427a1.007 1.007 0 0 1 1.007 1.007v6.608c0 .545-.285 1.067-.792 1.453-.507.385-1.195.602-1.912.602h-.25c-.717 0-1.405-.217-1.912-.602-.508-.386-.793-.908-.793-1.454v-6.607a1.007 1.007 0 0 1 1.007-1.007h3.645Zm-7.506 38.098c-.516 1.93.616 3.12 2.189 3.986.4.222.405.452.016.69l-2.538 1.54c-.322.2-.619.169-.89-.091-4.96-4.719-2.538-11.21 3.678-12.916 2.796-.766 7.864-1.298 9.87-3.37 2.896-2.996.69-6.883-2.622-8.347a.316.316 0 0 1 .009-.583l4.07-1.772a.67.67 0 0 1 .731.091c2.885 2.225 4.136 4.874 3.754 7.948-1.507 12.1-16.511 6.266-18.267 12.824Z",
    fill: "url(#private-secure-icon_svg__l)",
    transform: "translate(152 139.05)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.414 95.08a1.257 1.257 0 0 1-1.257-1.256l.017-3.886c.001-.516.283-1.01.784-1.374.5-.363 1.18-.566 1.887-.565h.316c.351 0 .7.051 1.024.15.324.099.619.243.867.424.248.182.445.398.579.635.134.237.202.49.202.746l-.017 3.887a1.257 1.257 0 0 1-1.257 1.256l-3.145-.016Zm4.685 14.622c2.388-1.173 3.745-3.054 2.055-5.65-.188-.289-.119-.489.208-.6l2.722-.923c.377-.128.638-.006.782.366 4.128 10.777-9.22 9.695-13.09 15.146-5.842 8.23 10.652 11.8 15.312 12.058.388.017.59.219.607.608l.05 1.098c.017.394-.172.591-.566.591-6.849.067-20.205-2.796-19.465-12.117.475-5.958 6.026-7.955 11.385-10.577Z",
    fill: "url(#private-secure-icon_svg__m)",
    transform: "translate(152 139.05)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.598 105.158c1.848-.457 4.094-1.256 5.218.816.155.294.125.563-.092.807-1.925 2.186-3.797 2.125-5.617-.183a.908.908 0 0 1 .491-1.44Zm5.5 20.397c2.597-2.679 3.33-6.166.076-8.654-.36-.278-.33-.502.091-.674l2.438-.999c.328-.139.594-.061.8.233 2.535 3.667 2.513 7.298-.067 10.893-.194.267-.455.366-.782.3l-2.38-.516c-.406-.089-.464-.283-.175-.583Z",
    fill: "url(#private-secure-icon_svg__n)",
    transform: "translate(152 139.05)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.694 118.107c3.087.907 2.613 5.043-.441 6.208a.908.908 0 0 1-.674-.008c-3.828-1.623-2.347-7.223 1.115-6.2Zm-5.468 13.748-6.05.716a.786.786 0 0 1-.84-.524c-.874-2.505 2.888-2.123 4.385-2.43.306-.067.589-.014.85.158l1.863 1.215c.727.471.658.76-.208.865Zm6.242 1.423a1.244 1.244 0 0 1 .88.346 1.234 1.234 0 0 1 .376.869v.108c.028 1.457-.207 2.859-.654 3.898-.446 1.039-1.067 1.631-1.726 1.645l-.616.016c-.327.008-.654-.128-.961-.399-.308-.27-.59-.671-.832-1.178a7.908 7.908 0 0 1-.574-1.777 11.531 11.531 0 0 1-.229-2.105v-.108a1.233 1.233 0 0 1 1.207-1.248l3.129-.067Z",
    fill: "url(#private-secure-icon_svg__o)",
    transform: "translate(152 139.05)"
  })));
};
export default SvgPrivateSecureIcon;